export const env = {
	NODE_ENV:
		process.env.REACT_APP_ENV ||
		('local' as 'local' | 'staging' | 'production'),

	// A P I
	API_URL: process.env.REACT_APP_API_URL!,

	// S E N T R Y
	SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN!,

	// O N E S I G N A L
	ONESIGNAL_ID: process.env.REACT_APP_ONESIGNAL_ID!,

	// G O O G L E
	GA_ID: process.env.REACT_APP_GA_ID!,
	MAPS_KEY: process.env.REACT_APP_MAPS_KEY!,

	// P A Y S T A C K
	PAYSTACK_PUB: process.env.REACT_APP_PAYSTACK_PUB!,

	// D A T A D O G
	DATADOG_APP_ID: process.env.REACT_APP_DATADOG_APP_ID!,
	DATADOG_CLIENT_TOKEN: process.env.REACT_APP_DATADOG_CLIENT_TOKEN!,

	// N E W R E L I C
	NEWRELIC_LICENCE: process.env.REACT_APP_NEWRELIC_LICENCE!,
	NEWRELIC_APP_ID: process.env.REACT_APP_NEWRELIC_APP_ID!,
	NEWRELIC_ACC_ID: process.env.REACT_APP_NEWRELIC_ACC_ID!,

	// P O S T H O G
	POSTHOG_HOST: process.env.REACT_APP_POSTHOG_HOST!,
	POSTHOG_TOKEN: process.env.REACT_APP_POSTHOG_TOKEN!,
};
